import {inject, Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {map} from 'rxjs/operators';

import {ResidentsModel} from '@intocare/residents/data';
import {Presence} from '@intocare/residents/shared';

import * as statistics from '../actions/resident.statistics';
import * as ui from '../actions/resident.ui';
import {ResidentStatistics} from '../entities/resident.statistics';
import * as reducers from '../reducers';

@Injectable()
export class ResidentStatisticsModel {
	private store = inject(Store);
	private residentsModel = inject(ResidentsModel);

	statistics$ = this.store.select(reducers.getResidentsStatistics);
	loading$ = this.store.select(reducers.getResidentsStatisticsLoading);

	loadStatistics() {
		this.store.dispatch(new ui.Loading());
		this.residentsModel.finalizedResidents$
			.pipe(
				map(result => result.filter(item => [Presence.P, Presence.A].includes(item.presence.presence))),
				map(
					(result): ResidentStatistics => ({
						female: result.reduce((acc, cur) => (cur.sex === 'f' ? ++acc : acc), 0),
						male: result.reduce((acc, cur) => (cur.sex === 'm' ? ++acc : acc), 0),
						other: result.reduce((acc, cur) => (cur.sex === 'o' ? ++acc : acc), 0),
						present: result.reduce((acc, cur) => (cur.presence.presence === Presence.P ? ++acc : acc), 0),
						absent: result.reduce((acc, cur) => (cur.presence.presence === Presence.A ? ++acc : acc), 0)
					})
				)
			)
			.subscribe(result => {
				this.store.dispatch(new statistics.SetStatistics(result));
			});
	}
}
